class CpProvidersDatatable {
    constructor(){
        let searchParams = new URLSearchParams(window.location.search);
        this.start = searchParams.get('start');
        this.end = searchParams.get('end');
        this.status = searchParams.get('status');
        this.organizationID = searchParams.get('organizationID');
        this.datatable = this.init('#cp-providers-datatable', this.organizationID);

    }
    init(el, organizationID){
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[0, 'desc']],
            ajax: {
                url: '?do=getCpProviders',
                type: 'POST',
                data: {
                    organizationID: organizationID
                }
            },
            searchCols: [
                null,
            ],
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=devices-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: null,
                    title: 'Identity',
                    sortable: true,
                    width: '69%',
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        if(data['uuid'] === null){
                            return '<div class="d-flex align-items-center">\n' +
                                '      <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">\n' +
                                '          <div class="symbol-label bg-light-primary border border-2 border-white">\n' +
                                '               <img src="/vendor/production/avatars/svg/'+ row['icon'] +'.svg" class="mw-35px mh-30px" alt="avatar">' +
                                '           </div>\n' +
                                '       </div>\n' +
                                '    <div class="d-flex justify-content-start flex-column">\n' +
                                '        <div>\n' +
                                '             <span class="fw-bold text-primary mb-1 fs-6 '+(row['roleID'] !== 1 ? 'text-decoration-underline-ga primary' : '')+'" id="'+row['uuid']+'">'+row['name']+'</span>\n' +
                                '        </div>\n' +
                                '        <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+row['under']+'</span>\n' +
                                '    </div>\n' +
                                '    </div>';
                        }
                        return '<div class="d-flex align-items-center">\n' +
                            '      <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">\n' +
                            '          <div class="symbol-label bg-light-primary border border-2 border-white">\n' +
                            '               <img src="/vendor/production/avatars/svg/'+ row['icon'] +'.svg" class="mw-35px mh-30px" alt="avatar">' +
                            '           </div>\n' +
                            '       </div>\n' +
                            '    <div class="d-flex justify-content-start flex-column">\n' +
                            '        <div>\n' +
                            '             <span class="fw-bold text-primary mb-1 fs-6 '+(row['roleID'] !== 1 ? 'edit-provider-cp text-decoration-underline-ga primary' : '')+'" '+(row['uuid'] !== null ? 'data-uuid="'+row['uuid']+'"' : '')+'data-uuid="'+row['uuid']+'" id="'+row['uuid']+'">'+row['name']+'</span>\n' +
                            '        </div>\n' +
                            '        <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+row['under']+'</span>\n' +
                            '    </div>\n' +
                            '    </div>';
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    width: '31%',
                    className: 'mw-425px',
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-3 d-flex align-items-center">';
                        if(row['roleID'] !== 1) {
                            if (data['uuid'] !== null) {
                                html += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-provider-cp" data-uuid="' + row['uuid'] + '" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Edit">' +
                                    '           <span class="svg-icon svg-icon-3">' +
                                    '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '                   <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>' +
                                    '                   <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>' +
                                    '               </svg>' +
                                    '           </span>' +
                                    '       </div>';
                                html += '<div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary me-2 delete-provider-cp cursor-pointer" data-uuid="' + row['uuid'] + '" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">' +
                                    '                   <span class="svg-icon svg-icon-3">' +
                                    '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                    '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                    '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                    '                       </svg>' +
                                    '                   </span>' +
                                    '               </div>';

                                html += '<div class="form-check form-switch form-check-custom form-check-solid d-inline ' + (data['is_active'] ? 'deactivate-provider-cp' : 'activate-provider-cp') + '" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="'+(data['is_active'] ? 'Disable' : 'Enable')+'"  data-uuid="' + row['uuid'] + '">\n' +
                                    '    <input class="form-check-input cursor-pointer" type="checkbox" value="" id="flexSwitchDefault"  ' + (data['is_active'] ? 'checked="checked"' : '') + '/>\n' +
                                    '</div>';

                            }
                        }


                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#cp-provider-search').hide();
                $('#cp-providers-datatable_wrapper').hide();
                $('#cp-providers-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        });
        // Add delay to datatable search
        new DatatableSearchDelay(datatable, '.cp-login-search');
        return datatable;
    }

}
window.CpProvidersDatatable = CpProvidersDatatable;